'use client'
import dynamic from 'next/dynamic';
import React from "react";
import {FilterVariant, IAppliedFilter, IDateFilterConfig} from "@/app/models/auctor";

const AppDatePicker = dynamic(() => import('@/app/components/atomic/molecules/AppDatePicker'));

export default function FilterDate({filterConfig, appliedFilter, handleChange, variant = "default"}: {
    filterConfig: IDateFilterConfig,
    appliedFilter: IAppliedFilter,
    handleChange: any,
    variant?: FilterVariant,
}) {
    const onChange = (newValue: any) => {
        handleChange(appliedFilter, newValue);
    }

    return (
        <div className="w-full">
            <AppDatePicker
                value={appliedFilter.value}
                minDate={filterConfig.min_filter_date}
                maxDate={filterConfig.max_filter_date}
                onChange={onChange}
                displayIcon
                variant="v2"
                birthdate={filterConfig.is_birthdate ?? false}
                gray={variant === "tool"}
            />
        </div>
    )
}
